import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { Card, Col, Container, } from 'react-bootstrap'
import moment from 'moment'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

function StartEndDate(props) {
    const { paymentData } = props
    return (
        <Container>
            <div className='mt-2'>
                <Card className='containerPaveCard pt-2 pb-2'>
                    <div className='align-items-center text-center d-flex'>
                        <Col className='startTimeClass lh-1'>
                            <span className='small d-flex justify-content-center pb-0 mb-0'>Start</span>
                            <small className='small header-s'>{moment(paymentData?.check_in_datetime).format('MM/DD/YYYY hh:mm A')}</small>
                        </Col>
                        <Col className='lh-1'>
                            <span className='small d-flex justify-content-center pb-0 mb-0'>End</span>
                            <small className='small header-s'>{moment(paymentData?.checkout_datetime).format('MM/DD/YYYY hh:mm A')}</small>
                        </Col>
                    </div>
                </Card>
            </div>
        </Container>
    )
}

StartEndDate.propTypes = {
    dispatch: PropTypes.func,
    paymentData: PropTypes.object
}

StartEndDate.defaulProps = {
    dispatch: noop,
    paymentData: EMPTY_OBJECT
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(StartEndDate)